export default "/_next/static/images/Japandi-e7b4739359d6658006e12234a6ac4f58.png";